import React, { useState } from "react";
import firebase from "./firebaseConfig";
import { useNavigate, Link } from "react-router-dom";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState("");
  const [isLoginLoading, setIsLoginLoading] = useState(false);
  const [isSignupLoading, setIsSignupLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setStatus("");
    setIsLoginLoading(true);
    
    try {
      const userCred = await firebase.auth().signInWithEmailAndPassword(email, password);
      localStorage.setItem("firebase_id_token", await userCred.user.getIdToken());
      setStatus("Login successful! Redirecting...");
      setTimeout(() => navigate("/dashboard"), 1000);
    } catch (err) {
      setStatus("Login failed: " + err.message);
    } finally {
      setIsLoginLoading(false);
    }
  };

  const handleSignup = async () => {
    setStatus("");
    setIsSignupLoading(true);
    
    try {
      const userCred = await firebase.auth().createUserWithEmailAndPassword(email, password);
      localStorage.setItem("firebase_id_token", await userCred.user.getIdToken());
      setStatus("Account created successfully! Redirecting...");
      setTimeout(() => navigate("/dashboard"), 1000);
    } catch (err) {
      setStatus("Registration failed: " + err.message);
    } finally {
      setIsSignupLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div style={{ marginBottom: '1rem' }}>
          <Link to="/" className="back-home-link">← Back to Home</Link>
        </div>
        <h1>Smart Web Chat</h1>
        
        <form onSubmit={handleLogin}>
          <div>
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              style={{ width: '100%' }}
            />
          </div>
          
          <div>
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              style={{ width: '100%' }}
            />
          </div>
          
          <div style={{ display: 'flex', gap: '1rem', flexDirection: 'column' }}>
            <button type="submit" className="btn-primary" disabled={isLoginLoading || isSignupLoading}>
              {isLoginLoading ? <span className="loading"></span> : ''} Connect
            </button>
            <button type="button" className="btn-secondary" onClick={handleSignup} disabled={isLoginLoading || isSignupLoading}>
              {isSignupLoading ? <span className="loading"></span> : ''} Create Account
            </button>
          </div>
        </form>
        
        {status && (
          <div className={`status ${status.includes('successful') || status.includes('Redirecting') ? 'success' : 'error'}`}>
            {status}
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;
